import flattenDeep from 'lodash/fp/flattenDeep';
import { isEqual } from 'lodash';
import { PiracyCommonProtocolFileResponse } from '../swagger/data-contracts';

type IFileData = File | PiracyCommonProtocolFileResponse | string;

export const downloadBlobFile = (data: IFileData, filename?: string): void => {
  let url: string;

  const link = document.createElement('a');

  if (data instanceof File) {
    url = window.URL.createObjectURL(data);
    link.setAttribute('download', data.name);
  } else {
    url = window.URL.createObjectURL(new Blob(['\ufeff' + data], { type: 'text/csv;charset=utf-8;' }));
  }

  link.href = url;
  if (filename) {
    link.setAttribute('download', filename);
  }

  document.body.appendChild(link);
  link.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(link);
};

export const getFilterSelected = (selectedItems: unknown[], list?: any[]) => {
  if (!selectedItems?.length) {
    return;
  }

  if (!list?.length) {
    return {
      count: `+${selectedItems.length}`,
    };
  }

  // selected value가 [-1]인 경우 All Selected
  if (JSON.stringify(selectedItems) === '[-1]') {
    return { name: String(list[0]?.label) };
  }

  const count = selectedItems.length;
  if (count > 0) {
    let selectedItem = list?.find((row) => {
      if (typeof selectedItems[0] === 'object') {
        // selected is array of {value: string, label: string}
        return selectedItems.find((item: any) => item.value === row.value);
      } else {
        // selected is array of primitive type
        return selectedItems.includes(row.value);
      }
    });

    if (!selectedItem) {
      list?.forEach((row) => {
        const selectedChild = row.children?.find((child: any) => {
          if (typeof selectedItems[0] === 'object') {
            // selected is array of {value: string, label: string}
            return selectedItems.find((item: any) => item.value === child.value);
          } else {
            // selected is array of primitive type
            return selectedItems.includes(child.value);
          }
        });
        if (selectedChild) {
          selectedItem = selectedChild;
        }
      });
    }

    const isGroupList = list?.some((item) => item.children);
    if (isGroupList) {
      const flattenList = flattenDeep(list?.map((item) => item.children));
      if (isEqual(flattenList?.map(({ value }) => value), selectedItems)) {
        return { name: 'All' };
      }
    } else {
      if (isEqual(list?.map(({ value }) => value), selectedItems)) {
        return { name: 'All' };
      }
    }

    return {
      name: selectedItem?.label,
      count: !selectedItem?.label ? `+${selectedItems.length}` : selectedItems.length > 1 ? `+${selectedItems.length - 1}` : undefined,
    };
  }
};
